import { gql } from '@apollo/client';

export const GET_READINESS_GAUGE_INSTANCES_QUERY = gql`
  query getReadinessGaugeInstancesQuery($group_id: String!) {
    readiness_gauge_instances(group_id: $group_id) {
      id
      deleted
      completed
      name
      created
      company {
        id
        name
      }
      country {
        id
        name
      }
      user {
        first_name
      }
      result {
        detail {
          name
        }
        summary
      }
      responses {
        id
        response
        question {
          id
        }
      }
    }
  }
`;

export const GET_READINESS_GAUGE_RESULTS_QUERY = gql`
  query getReadinessGaugeResults(
    $group_id: String!
    $readiness_gauge_instance: JSON!
    $responses: [JSON]!
  ) {
    readiness_gauge_results(
      group_id: $group_id
      readiness_gauge_instance: $readiness_gauge_instance
      responses: $responses
    ) {
      id
      result {
        summary
        detail {
          kpi {
            id
            description
            kpi_group {
              id
              name
            }
          }
          name
          total_score
          compliance_score
        }
      }
      responses {
        id
        response
        question {
          id
          name
          description
          kpi {
            id
            name
          }
          categories
          compliance_references
          sdg_references
        }
      }
    }
  }
`;
